import { defineComponent as _defineComponent } from 'vue'
import Stars from "./Stars.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'FeaturedReview',
  setup(__props) {


return { __sfc: true,Stars }
}

})